// /Users/stuartmcgeer/portalworx/frontend/src/pages/Dashboard/Dashboard.tsx

import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import StandardCard from '../../components/cards/StandardCard';
import axiosInstance from '../../services/axiosInstance';
import styles from './Dashboard.module.css';
import '../../styles/global/GlobalStyles.css'; // Import global styles

const getMediaBaseUrl = (): string => {
  return process.env.REACT_APP_MEDIA_BASE_URL || 'http://localhost:8000/media/';
};

const Dashboard: React.FC = () => {
  const { first_name, last_name, loading, error } = useAuth();
  const [profileData, setProfileData] = useState<any>(null);
  const [projects, setProjects] = useState<any[]>([]);

  useEffect(() => {
    // Fetch Profile Data
    const fetchProfileData = async () => {
      try {
        const response = await axiosInstance.get('/user/');
        setProfileData(response.data);
      } catch (err) {
        console.error('Error fetching profile data:', err);
      }
    };

    // Fetch Assigned Projects
    const fetchProjects = async () => {
      try {
        const response = await axiosInstance.get('/projects/?assigned=true');
        setProjects(response.data);
      } catch (err) {
        console.error('Error fetching projects:', err);
      }
    };

    fetchProfileData();
    fetchProjects();
  }, []);

  const profilePicUrl = profileData?.profile_picture
    ? `${getMediaBaseUrl()}${profileData.profile_picture}`
    : `${getMediaBaseUrl()}static/images/default_profile_picture.png`;

  if (loading) {
    return <div>Loading your dashboard...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className={styles.dashboardContainer}>
      <h1 className={styles.mainHeader}>Dashboard</h1>
      <h2 className={styles.subHeader}>
        Welcome to Your Dashboard, {first_name} {last_name}!
      </h2>
      <div className={styles.gridContainer}>
        {/* Profile Card */}
        <StandardCard>
          <h3>Profile</h3>
          {profileData ? (
            <div className={styles.profileCard}>
              <img
                src={profilePicUrl}
                alt="Profile"
                className={styles.profilePicture}
                onError={(e) =>
                  (e.currentTarget.src = `${getMediaBaseUrl()}static/images/default_profile_picture.png`)
                }
              />
              <p><strong>Username:</strong> {profileData.username}</p>
              <p><strong>First Name:</strong> {profileData.first_name}</p>
              <p><strong>Last Name:</strong> {profileData.last_name}</p>
              <p><strong>Email:</strong> {profileData.email}</p>
              <p><strong>Job Title:</strong> {profileData.job_title}</p>
              <p>
                <strong>User Type:</strong>{' '}
                <span
                  className={`userTypeLabel userType${profileData.user_type.charAt(0).toUpperCase() + profileData.user_type.slice(1)}`}
                >
                  {profileData.user_type}
                </span>
              </p>
            </div>
          ) : (
            <p>Loading profile...</p>
          )}
        </StandardCard>

        {/* Projects Card */}
        <StandardCard>
          <h3>Projects</h3>
          {projects.length > 0 ? (
            <ul>
              {projects.map((project) => (
                <li key={project.id}>
                  <a href={`/projects/${project.id}`}>{project.name}</a>
                </li>
              ))}
            </ul>
          ) : (
            <p>No projects assigned.</p>
          )}
        </StandardCard>
      </div>
    </div>
  );
};

export default Dashboard;
